// Copyright (c) 2022 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages } from "react-intl";
import { RoutedProps, withRouter } from "view/reactrouterinterceptor";
import { ISiteBarSearchFieldProps } from "view/comp/SiteBar";
import Power from "./Power";
import TrendSiteBar from "view/comp/TrendSiteBar";
import ModalTariffsFilter from "view/modal/ModalTariffsFilter";

const messages = defineMessages({
  placeholderSearchField: {
    id: "Highlight tariffs circuits...",
  },
});

class PowerPageComponent extends React.Component<RoutedProps> {
  public render() {
    const searchFieldProps: ISiteBarSearchFieldProps = {
      placeholder: messages.placeholderSearchField,
    };
    return (
      <>
        <TrendSiteBar showPeriodSelect={false} searchFieldProps={searchFieldProps} />
        <Power />
        <ModalTariffsFilter />
      </>
    );
  }
}

export default connect()(withRouter(PowerPageComponent));
